module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('server-side-data-table', {
    attrs: {
      "url": this.url,
      "columns": this.columns,
      "extras-column-name": _vm.trans('columns.actions'),
      "request-data": _vm.companyData,
      "storage-key": "users-index"
    },
    scopedSlots: _vm._u([{
      key: "extras",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "btn-group text-left"
        }, [(_vm.canImpersonateUser(row.data)) ? _c('a', {
          staticClass: "btn btn-dark btn-sm",
          class: {
            disabled: _vm.isImpersonateDisabled()
          },
          attrs: {
            "href": "#",
            "title": _vm.trans('messages.impersonate')
          },
          on: {
            "click": function($event) {
              return _vm.impersonate(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-hood-cloak"
        })]) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "btn btn-info btn-sm",
          attrs: {
            "href": _vm.route('users.show', row.data.id),
            "title": _vm.isImpersonateDisabled() ? _vm.trans('messages.already_impersonating') : _vm.trans('messages.details')
          }
        }, [_c('i', {
          staticClass: "fa fa-folder-open"
        })]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "href": "#",
            "title": _vm.trans('messages.password')
          },
          on: {
            "click": function($event) {
              return _vm.oneTimePassword(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-unlock-alt"
        })]), _vm._v(" "), (_vm.allowRemind) ? _c('a', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "href": "#",
            "title": _vm.trans('messages.reminder_mail')
          },
          on: {
            "click": function($event) {
              return _vm.sendReminderMail(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-at"
        })]) : _vm._e(), _vm._v(" "), (_vm.canEdit(row.data)) ? _c('a', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "href": _vm.route('users.edit', row.data.id),
            "title": _vm.trans('messages.edit')
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })]) : _vm._e(), _vm._v(" "), (_vm.canDelete(row.data)) ? _c('a', {
          staticClass: "btn btn-danger btn-sm confirm-delete",
          attrs: {
            "href": _vm.route('users.delete', row.data.id),
            "data-user-id": row.data.id,
            "data-method": "delete",
            "title": _vm.trans('messages.delete')
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-420d4ca9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Users.vue
// module id = 119
// module chunks = 0